import http from 'utils/http';

export const deletePaymentMethod = (cardId) => http
  .delete(`v1/organizations/{{organizationId}}/payment-methods/${cardId}`)
  .then(({ data }) => data);
